// import {InjectionToken} from "@angular/core";
//
// export const INT_ICON_PATH_TOKEN = new InjectionToken('token for icons int ux/ui lib');
import { InjectionToken } from '@angular/core';

export const INT_ICON_SPRITE_PATH_TOKEN = new InjectionToken<string>('INT_ICON_SPRITE_PATH_TOKEN', {
  factory: () => '/assets/icons/icons.svg',
});

export const INT_ICON_SPRITE_VERSION = new InjectionToken<string>('INT_ICON_SPRITE_VERSION', {
  factory: () => '0.0.2'
});
